import {useCallback} from 'react';
import {v4 as uuid} from 'uuid';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type UiInteractionEventParams = {
  item_name: string;
  interaction_details?: string;
  interaction_location: string;
  flow_name?: string;
  presentation_id?: string;
  asset_id?: string;
  original_id?: string;
  interaction_id?: string;
};

function useUiInteractionEvent() {
  const uiInteraction = useCallback(
    ({
      item_name,
      interaction_location,
      flow_name = '',
      presentation_id = '',
      asset_id = '',
      original_id = '',
      interaction_details = '',
      interaction_id = '',
    }: UiInteractionEventParams) => {
      const flow = flow_name ? AnalyticsService.getFlow(flow_name) : undefined;
      AnalyticsService.dispatchEvent(eventNames.CONTENT_STUDIO_UI_INTERACTION, {
        item_name,
        interaction_id: interaction_id || uuid(),
        interaction_location,
        flow_id: flow?.flow_id || '',
        presentation_id,
        asset_id,
        original_id,
        interaction_details,
      });
    },
    []
  );

  return {uiInteraction};
}

export default useUiInteractionEvent;
